import { IClassroomResource } from "../../classrooms";
import { IUserResource } from "../../users/types";
import { createApiQueryHook, IApiQueryFunction, mapRelationalValue, RelationalValue } from "../../utils";
import { serialize } from "../../utils/url";
import { ILearnerProgressionResource } from "../types";

export interface ILearnerProgressionQueryParameters {
    user?: RelationalValue<IUserResource>;
    classroom?: RelationalValue<IClassroomResource>;
}

export type ILearnerProgressionQueryResult = ILearnerProgressionResource;

export const learnerProgressionQuery: IApiQueryFunction<ILearnerProgressionQueryParameters> = ({ user, classroom }) => {
    if (!user) {
        return;
    }

    return {
        method: "GET",
        url: `/users/${mapRelationalValue(user)}/learner-progression${serialize(
            {
                activeClassroom_uuid: classroom ? mapRelationalValue(classroom) : undefined,
            },
            true,
        )}`,
    };
};

export const useLearnerProgressionQuery = createApiQueryHook<
    ILearnerProgressionQueryParameters,
    ILearnerProgressionQueryResult
>(learnerProgressionQuery);
